import styled from 'styled-components';

import { theme } from '../../../../global';
import * as InputTimeStyles from '../Time/styles';

export interface IInputCheckboxLabelStyles {
  $isBold?: boolean;
}

export const Container = styled(InputTimeStyles.Container)``;
export const Label = styled(InputTimeStyles.Label)<IInputCheckboxLabelStyles>`
  text-transform: none;
  font-weight: ${({ $isBold }) => ($isBold ? 700 : 500)};
`;

export const InputWrapper = styled.div<{ $isActive?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 22px;
  width: 40px;
  height: 24px;
  border: 1px solid
    ${({ $isActive }) => ($isActive ? theme.colors.toggle_bgrd_active : theme.colors.toggle_bgrd)};
  background-color: ${({ $isActive }) =>
    $isActive ? theme.colors.toggle_bgrd_active : theme.colors.toggle_bgrd};
  transition:
    border 0.1s ease-in-out,
    background-color 0.1s ease-in-out;
  overflow: hidden;

  input:checked ~ div {
    right: 0;
  }
`;

export const StyledInput = styled.input`
  z-index: 1;
  position: absolute;
  width: 40px;
  height: 40px;
  opacity: 0;
  cursor: pointer;
`;

export const Thumb = styled.div`
  pointer-events: none;
  position: absolute;
  right: 17px;
  width: 21px;
  height: 21px;
  border-radius: 50%;
  background-color: ${theme.colors.white};
  transition:
    left 0.1s ease-in-out,
    right 0.1s ease-in-out;
`;
